import { useGetContextOrError } from '@/lib/hooks/use-get-context-or-error';

import { context } from './context';

export const useResourceHubLayout = () =>
  useGetContextOrError(context, 'resource hub layout');
